import * as $ from 'jquery';
import './form-submit';
import './form-modal';
import './events';

(function () {
    $(function () {
        $(document).bind('ajaxStart', function() {
            setCursor('wait');
        });
        $(document).bind('ajaxComplete', function() {
            setCursor('default')
        });
        $(document).bind('ajaxError', function() {
            setCursor('default')
        });

        $('#aboutUsCollapse').on('show.bs.collapse', function() {
           $('#collapseButton').collapse('hide');
        });
    });
})();

function setCursor(value : string)
{
    $('html, body').css('cursor', value);
}



// WEBPACK FOOTER //
// ./assets/typescript/main.ts